"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyPlusModalStyleLink = exports.SankeyPlusModalStyleNode = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
const fa_1 = require("react-icons/fa");
const SankeyMenuConfigurationNodesAttributes_1 = require("open-sankey/dist/SankeyMenuConfigurationNodesAttributes");
const SankeyMenuConfigurationNodesLabel_1 = require("open-sankey/dist/SankeyMenuConfigurationNodesLabel");
const SankeyMenuConfigurationLinksAppearence_1 = require("open-sankey/dist/SankeyMenuConfigurationLinksAppearence");
const SankeyMenuConfigurationLinksLabel_1 = require("open-sankey/dist/SankeyMenuConfigurationLinksLabel");
// /**
//  * Variable that define the Menu element, it's variable and function
//  *
//  * @type {{ data: any; set_data: any; right_menu: any; settings_edition: any; settings_edition_node_tags: any; settings_edition_link_tags: any; settings_edition_data_tags: any; ... 39 more ...; launch: any; }}
//  */
// const MenuStyleNodePropTypes = {
//   t:PropTypes.func.isRequired,
//   data: PropTypes.shape(SankeyDataPropTypes).isRequired,
//   set_data: PropTypes.func.isRequired,
//   setShowStyle:PropTypes.func.isRequired,
//   showStyle:PropTypes.bool.isRequired,
//   selected_style_node: PropTypes.string.isRequired,
//   set_selected_style_node:PropTypes.func.isRequired
// }
// /**
//  * Description placeholder
//  *
//  * @typedef {MenuTypes}
//  */
// type MenuStyleNodeTypes = InferProps<typeof MenuStyleNodePropTypes>
const SankeyPlusModalStyleNode = (t, data, set_data, showStyle, setShowStyle, selected_style_node, set_selected_style_node, editable) => {
    if (selected_style_node !== 'default' && !editable) {
        set_selected_style_node('default');
    }
    const closeStyleEdition = () => {
        setShowStyle(false);
    };
    const tab_node_style_attribute = SankeyMenuConfigurationNodesAttributes_1.OpenSankeyConfigurationNodesAttributes(t, data, set_data, { current: [] }, true, selected_style_node);
    const applyStyleToNodes = () => {
        const style = data.style_node[selected_style_node];
        Object.values(data.nodes).filter(d => d.style !== '' && d.style === selected_style_node).map(d => {
            //Style Noeud
            d.shape_visible = style.shape_visible;
            d.color = style.color;
            d.shape = style.shape;
            d.node_width = style.node_width;
            d.node_height = style.node_height;
            //Syle label
            d.label_visible = style.label_visible;
            d.show_value = style.show_value;
            d.display_style.font_size = style.display_style.font_size;
            d.display_style.bold = style.display_style.bold;
            d.display_style.uppercase = style.display_style.uppercase;
            d.display_style.italic = style.display_style.italic;
            d.display_style.label_box_width = style.display_style.label_box_width;
            d.display_style.label_vert = style.display_style.label_vert;
            d.display_style.label_horiz = style.display_style.label_horiz;
            d.display_style.font_family = style.display_style.font_family;
        });
        set_data(Object.assign({}, data));
    };
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: showStyle, onHide: closeStyleEdition, size: 'lg' },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u00C9dition Style")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Row, null,
                (editable) ? react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            const new_style = SankeyUtils_1.default_node(data);
                            new_style.name = 'New Style';
                            const new_id = 'style_node_' + String(new Date().getTime());
                            data.style_node[new_id] = new_style;
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(fa_1.FaPlus, null))) : react_1.default.createElement(react_1.default.Fragment, null),
                (editable) ? react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success", id: "dropdown-basic" }, (selected_style_node !== '') ? SankeyUtils_1.cut_name(data.style_node[selected_style_node].name, 30) : 'Choix Style'),
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, Object.keys(data.style_node).map((d, i) => {
                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => { set_selected_style_node(d); } }, data.style_node[d].name));
                        })))) : react_1.default.createElement(react_1.default.Fragment, null),
                (editable) ? react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'danger', disabled: selected_style_node === 'default', onClick: () => {
                            delete data.style_node[selected_style_node];
                            set_selected_style_node((Object.keys(data.style_node).length > 0) ? Object.keys(data.style_node)[0] : '');
                        } },
                        react_1.default.createElement(fa_1.FaMinus, null))) : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "warning", onClick: applyStyleToNodes }, t('Noeud.apparence.asn')))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.ns'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { disabled: (selected_style_node === 'default') ? true : false, value: (selected_style_node !== '') ? data.style_node[selected_style_node].name : '', onChange: evt => {
                            data.style_node[selected_style_node].name = evt.target.value;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { md: 12 },
                react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "nodes_desc", id: "node_attributes" },
                    SankeyMenuConfigurationNodesAttributes_1.SankeyMenuConfigurationNodesAttributes(t, tab_node_style_attribute),
                    SankeyMenuConfigurationNodesLabel_1.SankeyMenuConfigurationNodesLabel(t, data, set_data, { current: [] }, true, 'default')))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: closeStyleEdition }, "Close"))));
};
exports.SankeyPlusModalStyleNode = SankeyPlusModalStyleNode;
//Modal et fonctions pour l'edition et affectation des style de flux
const SankeyPlusModalStyleLink = (t, data, set_data, showStyleLink, setShowStyleLink, selected_link, selected_style_link, set_selected_style_link, editable, additional_link_appearence_items) => {
    if (selected_style_link !== 'default' && !editable) {
        set_selected_style_link('default');
    }
    const closeStyleEditionLink = () => {
        setShowStyleLink(false);
    };
    const applyStyleToLinks = () => {
        const style = data.style_link[selected_style_link];
        Object.values(data.links).filter(d => d.style !== '' && d.style === selected_style_link).map(d => {
            d.recycling = style.recycling;
            d.orientation = style.orientation;
            d.arrow = style.arrow;
            // display_attribute
            d.label_position = style.label_position;
            d.orthogonal_label_position = style.orthogonal_label_position;
            d.label_on_path = style.label_on_path;
            d.label_visible = style.label_visible;
            d.text_color = style.text_color;
            d.color = style.color;
            d.gradient = style.gradient;
            d.curvature = style.curvature;
            d.curved = style.curved;
        });
        set_data(Object.assign({}, data));
    };
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: showStyleLink, onHide: closeStyleEditionLink, size: 'lg' },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "\u00C9dition Style")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Row, null,
                (editable) ? react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            const new_style = SankeyUtils_1.default_link(data);
                            new_style.idLink = 'New Style';
                            const new_id = 'style_link_' + String(new Date().getTime());
                            data.style_link[new_id] = new_style;
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(fa_1.FaPlus, null))) : react_1.default.createElement(react_1.default.Fragment, null),
                (editable) ? react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { disabled: !editable, variant: "success", id: "dropdown-basic" }, (selected_style_link !== '') ? SankeyUtils_1.cut_name(data.style_link[selected_style_link].idLink, 30) : 'Choix Style'),
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, Object.keys(data.style_link).map((d, i) => {
                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => { set_selected_style_link(d); } }, data.style_link[d].idLink));
                        })))) : react_1.default.createElement(react_1.default.Fragment, null),
                (editable) ? react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'danger', disabled: selected_style_link === 'default', onClick: () => {
                            delete data.style_link[selected_style_link];
                            set_selected_style_link((Object.keys(data.style_link).length > 0) ? Object.keys(data.style_link)[0] : '');
                        } },
                        react_1.default.createElement(fa_1.FaMinus, null))) : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "warning", onClick: applyStyleToLinks }, t('Flux.asf')))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.ns'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { disabled: !editable, value: (selected_style_link !== '') ? data.style_link[selected_style_link].idLink : '', onChange: evt => {
                            data.style_link[selected_style_link].idLink = evt.target.value;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { md: 12 },
                    react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "flux_attributes", id: "settings-layout" },
                        SankeyMenuConfigurationLinksAppearence_1.SankeyMenuConfigurationLinksAppearence(data, selected_link, { current: [] }, set_data, t, additional_link_appearence_items, true, selected_style_link),
                        SankeyMenuConfigurationLinksLabel_1.SankeyMenuConfigurationLinksLabel(data, { current: [] }, set_data, t, true, selected_style_link))))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: closeStyleEditionLink }, "Close"))));
};
exports.SankeyPlusModalStyleLink = SankeyPlusModalStyleLink;
